<ng-container>
    <div mat-dialog-title>
        <h2 *ngIf="!isUpdate">{{"content4.Add New Event" | translate}}</h2>
        <h2 *ngIf="isUpdate">{{"content4.Edit Event" | translate}}</h2>

        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
    <div *ngIf='loading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
  <ng-container  *ngIf="!loading">
    <form [formGroup]="formGroup">
        <mat-dialog-content class="pt-0 pb-0 mt-3 ">

            <div class="mat-dialog-body">
                <div class="fields-group">
                    <div class="image-uploader">
                        <div class="upload-container">
                            <label [for]="'fileUploadInput'">
                                <input type='file' #InputFile class="img-viewer" [id]="'fileUploadInput'"
                                    accept=".svg, image/png, image/jpeg, image/pjpeg"
                                    (change)="changeFileListener($event)">
                                <div class="image-preview photo">
                                    <img [src]="logoSrc" *ngIf="logoSrc">
                                </div>
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>{{ 'content4.Event Photo' | translate }}</label>
                            <p>
                                {{ 'content.JPG or PNG' | translate }}
                                <span>({{ 'content.MB max' | translate: {no: 1} }})</span>
                            </p>
                            <p class="mr-3 mt-1 grey-color info font-14">{{"content4.This photo will appear on BonTech Mobile App (for guests)" | translate }}
                            </p>
                        </div>
                    </div>
                    <p class="has-error" *ngIf="!logoSrc && isSubmitted && !(fileTypeError || fileSizeError)">{{
                        'forms.Required' | translate }}</p>
                    <p class="has-error" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p>
                    <p class="has-error" *ngIf="fileSizeError">{{ 'forms.Max-file-size' | translate }} {{maxFileSize}}
                        {{
                        'forms.MB' | translate }}</p>
                </div>
                <div class="fields-group mt-5">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="form-group mb-0" hideRequiredMarker>
                                <mat-label>{{"content4.Event Title in English" | translate}}</mat-label>
                                <input matInput formControlName="title_EN" maxlength="20">
                                <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}
                                </mat-error>
                                <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
                                    {{ 'forms.EntervalidNameinEnglish' | translate }}
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="form-group mb-0" hideRequiredMarker>
                                <mat-label>{{"content4.Event Title in Arabic" | translate}}</mat-label>
                                <input matInput formControlName="title_AR" maxlength="20">
                                <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}
                                </mat-error>
                                <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
                                    {{ 'forms.EntervalidNameinArabic' | translate }}
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 mt-1">
                            <span class="font-16 fontMedium grey-color">{{'content4.Event Date(s)' | translate}}</span>
                        </div>
                        <div class="col-sm-12 mb-1 mt-3">
                            <div class="grey-list-items">
                                <div class="list-item border border-raduis">
                                    <div class=" align-items-center">
                                        <div class="title font-16 fontMedium grey-color">{{'availabilty.Several Days' |
                                            translate}}</div>
                                        <span class="info no-icon font-12">{{"availabilty.Date range and you have to provide a start and end date" | translate}}</span>
                                    </div>
                                    <div>
                                        <mat-slide-toggle formControlName="isSeveralDays" (toggleChange)="onSeveralDaysChanges($event)"></mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6 mt-2">
                            <app-datepicker [label]="'availabilty.Start Date' | translate" [formGroup]="formGroup"
                                [controlName]="'startDate'" [isSubmitted]="isSubmitted"
                                (selectedDateChanged)="formGroup.controls['startDate'].setValue($event)">
                            </app-datepicker>
                        </div>
                        <div class="col-sm-6 mt-2" [hidden]="!formGroup.controls['isSeveralDays'].value">
                            <app-datepicker [label]="'availabilty.End Date' | translate" [formGroup]="formGroup"
                                [controlName]="'endDate'" [isSubmitted]="isSubmitted"
                                (selectedDateChanged)="formGroup.controls['endDate'].setValue($event)"
                                [min]="formGroup.controls['startDate'].value"
                                [required]="formGroup.controls['isSeveralDays'].value"
                                [showToday]="false"></app-datepicker>
                        </div>
                        <div class="col-sm-12 mt-2">
                            <span class="font-16 fontMedium grey-color">{{'content4.Event Time' | translate}}</span>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field hideRequiredMarker>
                                <mat-label> {{ 'content2.From' | translate }}</mat-label>
                                <input matInput [ngxTimepicker]="startTime" [format]="24" readonly
                                    formControlName="startTime" (ngModelChange)="validateDateTime()">
                                <div matSuffix class="d-flex align-items-center">
                                    <mat-icon matSuffix *ngIf="formGroup.controls['startTime'].value"
                                        (click)="formGroup.controls['startTime'].setValue('')">clear
                                    </mat-icon>
                                    <ngx-material-timepicker-toggle [for]="startTime"></ngx-material-timepicker-toggle>
                                </div>
                                <ngx-material-timepicker #startTime></ngx-material-timepicker>
                                <mat-error *ngIf="hasError('startTime', 'required')">{{ 'forms.Required' | translate
                                    }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field hideRequiredMarker>
                                <mat-label> {{ 'forms.To' | translate }}</mat-label>
                                <input matInput [ngxTimepicker]="endTime" [format]="24" readonly
                                    formControlName="endTime" (ngModelChange)="validateDateTime()"
                                    [min]="formGroup.controls['startTime'].value">
                                <div matSuffix class="d-flex align-items-center">
                                    <mat-icon matSuffix *ngIf="formGroup.controls['endTime'].value"
                                        (click)="formGroup.controls['endTime'].setValue('')">clear
                                    </mat-icon>
                                    <ngx-material-timepicker-toggle [for]="endTime"></ngx-material-timepicker-toggle>
                                </div>
                                <ngx-material-timepicker #endTime></ngx-material-timepicker>
                                <mat-error *ngIf="hasError('endTime', 'required')">{{ 'forms.Required' | translate
                                    }}
                                </mat-error>
                                <p class="has-error position-absolute mt-4" *ngIf="formGroup.controls['endTime'].value && formGroup.controls['startTime'].value === formGroup.controls['endTime'].value">{{ 'forms.Invalid' | translate
                                }}
                                </p>
                            </mat-form-field>

                        </div>
                        <div class="col-sm-12 mt-2 mb-3">
                            <span class="font-16 fontMedium grey-color">{{'content4.Manage Reservation Slots' | translate}}</span>

                            <p class="mr-3 mt-1 grey-color info font-14">{{"content4.It will reflect on reservations' slots for guests or the restaurant's host" | translate }}
                            </p>
                        </div>
                        <div class="col-md-12 d-flex" *ngIf="hours.length">
                            <a class="font-14 fontRegular grey-color ml-auto preventSelection"
                            (click)="selectAllSlots()"> <span *ngIf="!isHoursSelected">
                              {{'availabilty.Select All Slots' | translate}}</span>
                            <span *ngIf="isHoursSelected">{{'availabilty.Unselect All Slots' | translate}}</span>
                          </a>
                        </div>

                        <div class="col-md-12 mt-3">
                          <div class="py-3" *ngIf="hoursLoading">
                            <mat-spinner class="m-auto" diameter="30"></mat-spinner>
                          </div>
                          <div class="slots-select-list"
                            *ngIf="!hoursLoading && formGroup.controls['endTime'].value && formGroup.controls['startTime'].value">
                            <mat-selection-list class="circle-selection-list text-left" [formControl]="slots">
                                <ng-container *ngFor="let item of hours; index as index">
                                    <div class="d-inline-block">
                                        <mat-list-option class="mb-2"
                                            checkboxPosition="before"
                                            [value]="item"
                                            [selected]="item.isActive">
                                            {{item.timefrom}}
                                        </mat-list-option>
                                    </div>
                                </ng-container>
                            </mat-selection-list>
                            <div *ngIf="!hours.length">
                              {{"general.No Data Found" | translate}}
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 mt-4">
                            <mat-form-field>
                                <mat-label>{{"forms.Description" | translate}}</mat-label>
                                <textarea matInput formControlName="note"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 mb-2 mt-3">
                            <div class=" d-flex align-items-center">
                                <span class="font-16 fontRegular">{{'restaurant.Branches' | translate}}</span>
                                <a class="font-14 fontRegular grey-color ml-auto preventSelection"
                                    [ngClass]="{'disable-link': disableButton}"
                                    (click)="selectAllBranches()"> <span *ngIf="!isSelected">{{'availabilty.Select All Branches' |
                                        translate}}</span>
                                        <span *ngIf="isSelected">{{'availabilty.Unselect All Branches' |
                                            translate}}</span></a>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-2 mt-3">
                            <mat-selection-list class="circle-selection-list text-left" formControlName="branches">
                                <ng-container *ngFor="let item of allRestaurants; index as index">
                                    <div class="d-inline-block mr-2">
                                        <mat-list-option class="mb-2" [value]="item.id" checkboxPosition="before">
                                            {{item.name}}
                                        </mat-list-option>
                                    </div>
                                </ng-container>
                            </mat-selection-list>
                            <p class="has-error" *ngIf="isSubmitted && !formGroup.controls['branches'].value?.length">{{'forms.Required' | translate}}</p>
                        </div>
                    </div>
                </div>



                <div class="grey-list-items form-group mt-3">
                    <div class="list-item sub-list-item-dashed">
                        <div class="d-flex align-items-center">
                            <p class="mr-3 grey-color info font-14">{{"content4.Once you submit, it will be published on the BonTech Mobile App" | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
            <button *ngIf="!isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
                [class.loading]="loading">
                {{"content4.Add Event" | translate}}
            </button>
            <button *ngIf="isUpdate" (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
                [class.loading]="loading">
                {{"content4.Edit Event" | translate}}
            </button>
        </mat-dialog-actions>
    </form>
  </ng-container>
</ng-container>
